export const ROUTINE_PROMISE_ACTION = '@@redux-saga-routines/PROMISE'

export enum ROUTINE_STAGE {
  TRIGGER = 'TRIGGER',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
}

export const routineStages = [ROUTINE_STAGE.TRIGGER, ROUTINE_STAGE.SUCCESS, ROUTINE_STAGE.FAILURE]
